import * as Yup from 'yup'

import { EMPTY_LIST } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { isFormArrayFieldsEqual } from '../../../../utils/formHelpers'
import {
  EntityActionTypeSelectOptionValue,
  getEntityActionTypeSelectOptions,
  isRemoveAllEntityActionType,
} from '../../../Entity'
import { formValidationSchemaNoChanged } from '../../../Form'
import { FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME } from '../../../Formik'

import {
  BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS,
  BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS,
  EDIT_BUILDINGS_GROUP_FORM_INITIAL_VALUES,
} from './BuildingsEditBuildingsGroupActionModal.constants'

export function getInitialValues(initialValue, itemAction) {
  const actionTypeOptions = getEntityActionTypeSelectOptions()

  return {
    ...EDIT_BUILDINGS_GROUP_FORM_INITIAL_VALUES,
    [BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS]: initialValue,
    [FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME]: itemAction
      ? actionTypeOptions[EntityActionTypeSelectOptionValue.Edit]
      : actionTypeOptions[EntityActionTypeSelectOptionValue.Add],
  }
}

export function getValidationSchema({ initialValues, itemAction }) {
  return Yup.object({
    [BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS]:
      Yup.array().when(FORMIK_ENTITY_ACTION_CONFIG_FIELDS_TYPE_SELECT_NAME, {
        is: actionType =>
          !isRemoveAllEntityActionType(actionType) && !itemAction,
        then: schema => schema.of(Yup.object()).min(1, true),
      }),
  }).when(EMPTY_LIST, {
    is: () => itemAction,
    then: schema =>
      schema.concat(
        formValidationSchemaNoChanged({
          initialValues,
          isEqual: isFormArrayFieldsEqual,
          isEqualProps: {
            name: BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS,
          },
        })
      ),
  })
}

export function getSubmitPayload(values) {
  return {
    [BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS]:
      values[BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_UPDATE_MANAGERS],
    ids: getItemsIds(
      values[BUILDINGS_EDIT_BUILDINGS_GROUP_FIELD_NAME_BUILDING_GROUPS],
      'value'
    ),
  }
}
